import { type PageType } from '@wix/cashier-common/dist/src/enums/PageType';
import { type Translations } from '../types/Translations';
import { type CreditCardFormBIData } from '../types/Config';
import { initI18n } from './i18n';
import { updateBILoggerDefaults } from './biLogger';

export interface InitI18nAndBiParams {
  locale: string;
  l10n: Translations;
  appId: string;
  appInstanceId: string;
  orderId?: string;
  biData?: CreditCardFormBIData;
  visitorId: string;
  msid: string;
  checkoutSessionId?: string;
  appSessionId?: string;
  pageType?: PageType;
}

export function initI18nAndBi(params: InitI18nAndBiParams): void {
  initI18n(params.locale, params.l10n);
  updateBILoggerDefaults({
    appId: params.appId,
    appInstanceId: params.appInstanceId,
    orderSnapshotId: params.orderId,
    mobileAppId: params.biData?.mobileAppId,
    mobileAppVersion: params.biData?.mobileAppVersion,
    visitorId: params.visitorId,
    msid: params.msid,
    checkoutSessionId: params.checkoutSessionId,
    appSessionId: params.appSessionId,
    pageType: params.pageType,
  });
}
